/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Represents the communication style of an employee
 */
export enum EmployeePersonalityCommunicationStyle {
    PROFESSIONAL = 'professional',
    FRIENDLY = 'friendly',
    ASSERTIVE = 'assertive',
    TECHNICAL = 'technical',
}
